import React, { useEffect, useState } from "react";
import {
  Box,
  Typography,
  Paper,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  TablePagination,
  Button,
  Tabs,
  Tab,
} from "@mui/material";
import { Col, Row } from "reactstrap";
import { useDispatch, useSelector } from "react-redux";
import { useLocation, useNavigate } from "react-router-dom";
import Sidebar from "../../../SideBar";
import { fetchLcaState } from "../../../../redux/slices/LcaSlice";
import { escapeCSV } from "../../../../utils/csvUtils";
import { setClicksTab } from "../../../../redux/slices/ReportsSlice";
import CustomerClicks from "./CustomerClicks";
import BusinessClicks from "./BusinessClicks";
import { fetchBWV } from "../../../../components/Header/Data";

const Header = ({ handleBack, handleDownloadClick, filteredCustomers }) => {
  const { clicksTab } = useSelector((state) => state.reports);
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const location = useLocation();

  const handleTabChange = (event, newValue) => {
    dispatch(setClicksTab(newValue));
    const searchParams = new URLSearchParams(location.search);
    searchParams.set(
      "tab",
      newValue === "NEEDS" ? "Customers" : "business-listing"
    );
    navigate(
      {
        pathname: location.pathname,
        search: searchParams.toString(),
      },
      { replace: true }
    );
  };

  return (
    <Box
      sx={{
        display: "flex",
        alignItems: "center",
        justifyContent: "space-between",
        mb: { xs: 2, sm: 3 },
        flexWrap: "wrap",
        gap: { xs: 1, sm: 2 },
      }}
    >
      <Box
        sx={{
          display: "flex",
          alignItems: "center",
          gap: { xs: 1, sm: 2 },
          width: { xs: "100%", sm: "auto" },
        }}
      >
        <Button
          variant="outlined"
          onClick={handleBack}
          sx={{
            minWidth: { xs: "auto", sm: "auto" },
            borderRadius: "8px",
            textTransform: "none",
            fontWeight: 500,
            fontSize: { xs: "0.75rem", sm: "0.875rem" },
            padding: { xs: "4px 8px", sm: "6px 12px" },
          }}
        >
          ← Back
        </Button>
        <Tabs
          value={clicksTab}
          onChange={handleTabChange}
          sx={{
            "& .MuiTabs-flexContainer": {
              justifyContent: { xs: "space-between", sm: "flex-start" },
            },
            "& .MuiTab-root": {
              textTransform: "none",
              fontWeight: 500,
              fontSize: { xs: "0.75rem", sm: "0.875rem", md: "1rem" },
              padding: { xs: "8px 12px", sm: "10px 16px" },
              minWidth: { xs: "auto", sm: "120px" },
              flex: { xs: "1", sm: "initial" }, // Equal width on mobile
            },
            "& .Mui-selected": {
              textDecoration: "underline",
              textDecorationThickness: "2px",
              textUnderlineOffset: "4px",
            },
            "& .MuiTabs-indicator": {
              display: "none", // Hide default indicator, using underline instead
            },
          }}
        >
          <Tab label="Customers" value="NEEDS" />
          <Tab label="Business Listing" value="SERVICES" />
        </Tabs>
      </Box>
      {/* <Button
        variant="contained"
        // onClick={handleDownloadClick}
        // disabled={filteredCustomers.length === 0}s
        sx={{
          borderRadius: "8px",
          textTransform: "none",
          fontWeight: 500,
          fontSize: { xs: "0.75rem", sm: "0.875rem" },
          padding: { xs: "4px 8px", sm: "6px 12px" },
          width: { xs: "100%", sm: "auto" },
        }}
      >
        Download as CSV
      </Button> */}
    </Box>
  );
};

const UsersClicksReport = () => {
  const islogin = useSelector((state) => state.user.isLogin);
  const userinfo = useSelector((state) => state.user.userInfo);
  const user = islogin ? JSON.parse(userinfo) : null;
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const [page, setPage] = useState(0);
  const customers = useSelector((state) => state.lcAds.Lca);
  const [businessList, setBusinessList] = useState([]);
  const { clicksTab } = useSelector((state) => state.reports);
  // Fetch LCA data
  const fetchLCA = async () => {
    let pageNumber = 1;
    while (true) {
      const payload = {
        pageId: pageNumber,
        userId: islogin ? user?.UserID : null,
      };
      const result = await dispatch(fetchLcaState(payload)).unwrap();
      if (result.length < 50) break;
      pageNumber++;
    }
    const bwvData = await fetchBWV();
    const filterBwvData = bwvData.filter((vendor) => vendor.isactive === "3");
    setBusinessList(filterBwvData);
  };

  useEffect(() => {
    fetchLCA();
  }, [dispatch, islogin, user?.UserID]);

  // Handlers for pagination
  //   const handleChangePage = (event, newPage) => {
  //     setPage(newPage);
  //   };

  //   const handleChangeRowsPerPage = (event) => {
  //     setRowsPerPage(parseInt(event.target.value, 10));
  //     setPage(0);
  //   };

  // Handle Back button click
  const handleBack = () => {
    navigate(-1);
  };

  // Handle Download button click
  //   const handleDownloadClick = () => {
  //     if (filteredCustomers.length === 0) return;

  //     // Get headers from the first customer object, excluding eventDetails
  //     const firstCustomer = filteredCustomers[0];
  //     const eventDetails =
  //       JSON.parse(firstCustomer.eventDetails || "[]")[0] || {};
  //     const baseKeys = Object.keys(firstCustomer).filter(
  //       (key) => key !== "eventDetails"
  //     );
  //     const eventDetailKeys = Object.keys(eventDetails).map(
  //       (key) => `eventDetails.${key}`
  //     );
  //     const headers = [...baseKeys, ...eventDetailKeys];

  //     // Generate CSV rows
  //     const rows = filteredCustomers.map((customer) => {
  //       const eventDetails = JSON.parse(customer.eventDetails || "[]")[0] || {};
  //       return headers
  //         .map((header) => {
  //           if (header.startsWith("eventDetails.")) {
  //             const key = header.split(".")[1];
  //             return escapeCSV(
  //               key === "eventDate" && eventDetails[key]
  //                 ? new Date(eventDetails[key]).toLocaleString()
  //                 : eventDetails[key] || "N/A"
  //             );
  //           }
  //           return escapeCSV(customer[header] || "N/A");
  //         })
  //         .join(",");
  //     });

  //     // Create CSV content
  //     const csvContent = [headers.join(","), ...rows].join("\n");
  //     const blob = new Blob([csvContent], { type: "text/csv;charset=utf-8;" });
  //     const url = URL.createObjectURL(blob);
  //     const link = document.createElement("a");
  //     link.setAttribute("href", url);
  //     link.setAttribute("download", "customers_150_plus_guests.csv");
  //     document.body.appendChild(link);
  //     link.click();
  //     document.body.removeChild(link);
  //     URL.revokeObjectURL(url);
  //   };

  return (
    <section className="home-after-loginhydroxychloroquine bg-white">
      <div className="container">
        <Row className="Report-container px-0">
          <Col sm={3} className="stgs_sbar mt-2 mx-0">
            <Sidebar />
          </Col>
          <Col sm={9} className="stgs_content mt-2">
            <Box sx={{ p: { xs: 2, sm: 3 } }}>
              <Header
                handleBack={handleBack}
                // handleDownloadClick={handleDownloadClick}
                // filteredCustomers={filteredCustomers}
              />
              {clicksTab === "NEEDS" ? (
                <CustomerClicks />
              ) : (
                <BusinessClicks businessList={businessList} />
              )}
            </Box>
          </Col>
        </Row>
      </div>
    </section>
  );
};

export default UsersClicksReport;
